export const getIncome = (state) => state.income;
export const getExpenses = (state) => state.expenses;
